import {connect} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {getAllVerifyResponse} from "../store/logIn";
import Header from "../blocks/header";
import Dashboard from "../blocks/dashboard";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";
import Box from "@mui/material/Box";
import Copyright from "../blocks/copyright";
import {useTranslation} from "react-i18next";
import AdminFilter from "../blocks/AdminFilter";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import DeleteProblem from "../blocks/deleteProblem";
import {toast} from "react-toastify";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import {getAlLProblems, messageReset} from "../store/problems";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SearchIcon from "@mui/icons-material/Search";
import {FormControl, InputAdornment, InputLabel, OutlinedInput, Pagination} from "@mui/material";

const PAGE_SIZE = 20

function Problems(props) {
    const is_main = JSON.parse(localStorage.getItem('is_main'));
    const navigate = useNavigate()
    const {t} = useTranslation()
    const params = useParams()
    const regionId = params.id || false

    const [open, setOpen] = useState(false)
    const [openItem, setOpenItem] = useState(false)
    const [searchCompany, setSearchCompany] = useState('')
    const [page, setPage] = useState(1)
    const [searchTimer, setSearchTimer] = useState(null)
    const [answeredFilter, setAnsweredFilter] = useState('')
    const [adminRegionId, setAdminRegionId] = useState('')

    function fetchData(pg, sc, answered) {
        const _rid = regionId || adminRegionId || ''
        const _answered = answered !== undefined ? answered : answeredFilter
        props.getAlLProblems(
            pg || page, PAGE_SIZE,
            sc !== undefined ? sc : searchCompany,
            _rid, '', '', is_main ? _answered : ''
        )
    }

    function handleAdminFilter({regionId: r}) {
        const rid = r || ''
        setAdminRegionId(rid); setPage(1)
        props.getAlLProblems(1, PAGE_SIZE, searchCompany, rid, '', '', answeredFilter)
    }

    useEffect(() => {
        const token = localStorage.getItem('token')
        if (token !== 'undefined') {
            props.getAllVerifyResponse({"token": JSON.parse(token)})
        }
        fetchData(1, '')
    }, [])

    useEffect(() => {
        if (props.verify === false) navigate("/login/")
    }, [props.verify])

    useEffect(() => {
        if (props.message === 'deleted') {
            toast.success(t('delete_success'), {theme: 'colored'})
            setOpenItem(false); props.messageReset(); fetchData()
        } else if (props.message === 'error') {
            toast.error(t('save_error'), {theme: 'colored'}); props.messageReset()
        } else if (props.message === true) {
            toast.success(t('save_success'), {theme: 'colored'}); props.messageReset()
        }
    }, [props.message])

    useEffect(() => {
        if (is_main) { setPage(1); fetchData(1, '', answeredFilter) }
    }, [answeredFilter])

    useEffect(() => {
        if (searchTimer) clearTimeout(searchTimer)
        const timer = setTimeout(() => { setPage(1); fetchData(1, searchCompany) }, 400)
        setSearchTimer(timer)
    }, [searchCompany])

    function handlePageChange(e, value) {
        setPage(value); fetchData(value)
        window.scrollTo({top: 0, behavior: 'smooth'})
    }

    function getFullDateTime(val) {
        let d = new Date(val)
        let date = String(d.getDate()).padStart(2,'0')
        let month = String(d.getMonth()+1).padStart(2,'0')
        return `${date}.${month}.${d.getFullYear()} ${d.getHours()}:${String(d.getMinutes()).padStart(2,'0')}`
    }

    const problems = props.problems || []
    const ANSWER_FILTERS = [
        {val: '',             label: t('all')},
        {val: 'not_answered', label: t('not_answered')},
        {val: 'answered',     label: t('answered')},
    ]

    return <div>
        <div className={'page worker-page problems'}>
            {open ? <DeleteProblem setOpenItem={setOpenItem} openItem={openItem} open={open} setOpen={setOpen}/> : ''}
            <Header/>
            <Dashboard/>
            <Box component="main" sx={{flexGrow: 1, height: '100vh', overflow: 'auto'}}>
                <Toolbar/>
                <div className={'main'}>
                    <Button variant="outlined" startIcon={<ChevronLeftIcon/>} onClick={() => navigate(-1)}>
                        {t('back')}
                    </Button>
                    <div className={'header-page'}>
                        <h2 className={'page-title'}>{t('problems')}</h2>
                        {!is_main && (
                            <Button variant="contained" endIcon={<AddIcon/>} onClick={() => navigate('/add-problem/')}>
                                {t('add_problem')}
                            </Button>
                        )}
                    </div>

                    {is_main && !regionId && <AdminFilter onFilter={handleAdminFilter}/>}

                    {is_main && (
                        <div style={{marginBottom: '16px', display: 'flex', gap: '16px', flexWrap: 'wrap', alignItems: 'center'}}>
                            <FormControl variant="outlined" style={{minWidth: 300}}>
                                <InputLabel htmlFor="search-prob">{t('search_company')}</InputLabel>
                                <OutlinedInput
                                    id="search-prob" value={searchCompany}
                                    onChange={(e) => setSearchCompany(e.target.value)}
                                    endAdornment={<InputAdornment position="end"><SearchIcon/></InputAdornment>}
                                    label={t('search_company')}/>
                            </FormControl>
                            <div style={{display: 'flex', gap: '8px', flexWrap: 'wrap'}}>
                                {ANSWER_FILTERS.map(({val, label}) => (
                                    <button key={val} onClick={() => setAnsweredFilter(val)}
                                        style={{
                                            padding: '8px 18px', borderRadius: '20px', cursor: 'pointer', fontSize: '13px',
                                            border: answeredFilter === val ? 'none' : '1px solid #d1d5db',
                                            background: answeredFilter === val ? '#1F4E79' : '#fff',
                                            color: answeredFilter === val ? '#fff' : '#374151',
                                            fontWeight: answeredFilter === val ? 600 : 400,
                                        }}>{label}</button>
                                ))}
                            </div>
                        </div>
                    )}

                    {problems.length ? (
                        <table className="table table-hover table-responsive">
                            <thead>
                            <tr>
                                <th>#</th>
                                {is_main && <th>{t('title_company')}</th>}
                                <th>{t('problem_title')}</th>
                                {is_main && <th>{t('answered')}</th>}
                                <th>{t('problem_date')}</th>
                                <th/>
                            </tr>
                            </thead>
                            <tbody>
                            {problems.map((item, index) => (
                                <tr key={item.id}>
                                    <th>{(page-1)*PAGE_SIZE + index + 1}</th>
                                    {is_main && <td>{item.user?.user_name || 'ADMIN'}</td>}
                                    <td>{item.title}</td>
                                    {is_main && (
                                        <td>
                                            <span style={{
                                                padding: '3px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: 500,
                                                background: item.is_answered ? '#dcfce7' : '#fef9c3',
                                                color: item.is_answered ? '#15803d' : '#92400e',
                                            }}>
                                                {item.is_answered ? t('answered') : t('not_answered')}
                                            </span>
                                        </td>
                                    )}
                                    <td>{getFullDateTime(item.modified)}</td>
                                    <td>
                                        {is_main ? (
                                            <>
                                                <Button variant="contained" color="primary" endIcon={<VisibilityIcon/>}
                                                        onClick={() => navigate('/view-problem/' + item.id)}
                                                        style={{marginRight: '4px'}}/>
                                                <Button variant="contained" color="error" endIcon={<DeleteIcon/>}
                                                        onClick={() => { setOpenItem(item); setOpen(true) }}/>
                                            </>
                                        ) : item.is_answered ? (
                                            <Button variant="contained" color="primary" endIcon={<VisibilityIcon/>}
                                                    onClick={() => navigate('/view-problem/' + item.id)}/>
                                        ) : (
                                            <>
                                                <Button variant="contained" color="info" endIcon={<EditIcon/>}
                                                        onClick={() => navigate('/edit-problem/' + item.id)}
                                                        style={{marginRight: '4px'}}/>
                                                <Button variant="contained" color="error" endIcon={<DeleteIcon/>}
                                                        onClick={() => { setOpenItem(item); setOpen(true) }}/>
                                            </>
                                        )}
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    ) : (
                        <div className={'no-infos'}>{t('no_info')}</div>
                    )}

                    {props.total_pages > 1 && (
                        <div style={{display: 'flex', justifyContent: 'center', padding: '20px 0'}}>
                            <Pagination count={props.total_pages} page={page}
                                        onChange={handlePageChange} color="primary" shape="rounded"/>
                        </div>
                    )}
                </div>
                <Copyright/>
            </Box>
        </div>
    </div>
}

export default connect(props => props.problems, {getAlLProblems, getAllVerifyResponse, messageReset})(Problems)
